import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';

/** Version applicative pour le reporting (native = versionName/CFBundleShortVersion, web = env). */
export async function getAppVersion(): Promise<string> {
  if (Capacitor.isNativePlatform()) {
    try {
      const info = await CapApp.getInfo();
      if (info?.version) return info.version;
    } catch { /* fallthrough */ }
  }
  return import.meta.env.VITE_APP_VERSION ?? 'web';
}
